import React from 'react';
import { useAnalytics } from '@carvana/analytics';
import { CarvanaHeaderContext } from '@carvana/header';

import {
  StyledContainer,
  StyledButton,
  StyledChatIconContainer,
  StyledChatIcon,
  StyledTextBlock,
  StyledText
} from './styles';

const Chat = () => {
  const { trackEvent } = useAnalytics();

  return (
    <CarvanaHeaderContext.Consumer>
      {(headerContext) => (
        <StyledContainer>
          <StyledButton
            href="#"
            onClick={(ev) => {
              ev.preventDefault();
              trackEvent(
                'content_engagement',
                {
                  clickstream: { engagement_type: 'chat_with_us_link' }
                },
                ['clickstream']
              );
              headerContext.openChat();
            }}
          >
            <StyledChatIconContainer>
              <StyledChatIcon />
            </StyledChatIconContainer>
            <StyledTextBlock>
              <StyledText>Chat with us</StyledText>
            </StyledTextBlock>
          </StyledButton>
        </StyledContainer>
      )}
    </CarvanaHeaderContext.Consumer>
  );
};

export default Chat;
